export default __webpack_public_path__ + "static/media/kitcollab-thumbnail-no-buttons.0e225611.png";